// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../common/style/reset.css'
import '../common/style/lexue-common.css'
import '../common/style/element-variables.scss'
import 'font-awesome/css/font-awesome.min.css'

import Vue from 'vue'
import {Container,Main,Row,Col,Form,FormItem,Input,Button,Loading,Message,MessageBox, Result} from 'element-ui'
import { abilitiesPlugin } from '@casl/vue'

import App from './App'
import router from './router'
import store from './store'
import { xhrGet, xhrPost, xhrPut, xhrPatch, xhrDelete, xhrFilePost, xhrFilePut, isLoggedUser } from './util/xhr-apis'
import './util/vue-filters'
Vue.config.productionTip = false
Vue.use(Container);
Vue.use(Main);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
Vue.use(Result);
Vue.use(Loading);
Vue.use(abilitiesPlugin)

Vue.prototype.$xhrGet = xhrGet
Vue.prototype.$xhrPost = xhrPost
Vue.prototype.$xhrPut = xhrPut
Vue.prototype.$xhrDelete = xhrDelete
Vue.prototype.$xhrPatch = xhrPatch
Vue.prototype.$xhrFilePost = xhrFilePost
Vue.prototype.$xhrFilePut = xhrFilePut
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$isLoggedUser = isLoggedUser

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/sso/main.js